
export const isPasteProduct = (product) => {
  const paste_product_slugs = [
    'm8-no-clean-solder-paste',
    'm8-no-clean-lead-free-solder-paste',
    'ws488-water-soluble-solder-paste',
    'ws488-water-soluble-lead-free-solder-paste',
  ]

  return paste_product_slugs.includes(product.slug);
}